import styled from 'styled-components';
import { colors } from "colors";
import { ReactComponent as CloseIcon } from "assets/svgs/closeIcon.svg";

const flexBasisMap = {
  id: "30px",
  name: "335px",
  cost: "55px",
  qty: "50px",
  desc: "380px",
  price: "30px"
};

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #dee2e6;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-flow: column;
`;

export const HeaderActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const PurchaseOrderTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.6px;
  color: #0d0d0e;
  margin: 3px 0 8px 0;
`;

export const PurchaseOrderNumber = styled.p`
  font-size: 14px;
  letter-spacing: 0.5px;
  color: #0d0d0e;
  margin: 0;
`

export const CloseButton = styled(CloseIcon)`
  cursor: pointer;
  &:hover {
    fill: ${colors.brightBlue};
  }
  padding: ${props => props.padding ? props.padding : '0 10px 10px 0'};
  width: 12px;
  height: 12px;
  fill: ${colors.steel};
`;

export const AttrHeading = styled.span`
  color: #5e6164;
box-sizing: border-box;
color: rgb(135, 140, 144);
display: block;
font-feature-settings: "liga";
font-size: 14px;
font-variant-caps: normal;
font-variant-east-asian: normal;
font-variant-ligatures: common-ligatures;
font-variant-numeric: normal;
font-weight: 400;
height: 14px;
letter-spacing: -0.34px;
line-height: 14px;
margin-block-end: 0px;
margin-block-start: 0px;
margin-bottom: 0px;
margin-inline-end: 0px;
margin-inline-start: 0px;
margin-top: 0px;
pointer-events: auto;
text-align: left;
text-rendering: optimizelegibility;
text-size-adjust: 100%;
width: 369.5px;
`;

export const AttrValue = styled.span`
  color: #363839;
  box-sizing: border-box;
  color: rgb(13, 13, 14);
  display: block;
  font-feature-settings: "liga";
  font-size: 14px;
  font-variant-caps: normal;
  font-variant-east-asian: normal;
  font-variant-ligatures: common-ligatures;
  font-variant-numeric: normal;
  font-weight: 400;
  height: 14px;
  letter-spacing: -0.34px;
  line-height: 14px;
  margin-block-end: 0px;
  margin-block-start: 8px;
  margin-bottom: 0px;
  margin-inline-end: 0px;
  margin-inline-start: 0px;
  margin-top: 8px;
  pointer-events: auto;
  text-align: left;
  text-rendering: optimizelegibility;
  text-size-adjust: 100%;
  width: 369.5px;
  word-break: break-all;
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom-color: rgb(222, 226, 230);
  border-bottom-style: solid;
  border-bottom-width: 1px;
`;

export const VerticalLayout = styled.div`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  padding: ${props => props.padding ? props.padding : '0'};
`;

export const StatusBarWrapper = styled.div`
  background-color: ${props => props.coloring.bgColor ? props.coloring.bgColor: '#fff'};
  border: ${props => props.coloring.border ? props.coloring.border : 'none'};
  color: ${props => props.coloring.color ? props.coloring.color : 'black'};
  display: block;
  height: 49px;
  text-align: center;
  text-rendering: optimizelegibility;
  text-size-adjust: 100%;
  text-transform: uppercase;
`;

export const POStatus = styled.p`
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.5px;
  padding: 15px 0;
  margin: 0;
`

export const RequestDetailsWrapper = styled.div`
  display: flex;
  flex-flow: column;
  padding: 20px 30px;
  border-bottom: 1px solid #dee2e6;
`;

export const DetailSpan = styled.span`
  font-weight: ${props => props.fontBold ? 'bold' : ''};
  padding: ${props => props.padding ? props.padding : '0'};
  word-break: ${props => props.breakWord ? 'break-all': ''};
`;

export const MultiDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.padding ? props.padding : '0 0 20px 0'};
`;

export const SingleDetailRow = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  padding: ${props => props.padding ? props.padding : '0'};
  margin: ${props => props.margin ? props.margin : ''};
  ${DetailSpan}:nth-child(1) {
    margin-bottom: 4px;
    font-size: 14px;
    color: ${colors.steel};
  }
  ${DetailSpan}:nth-child(2) {
    font-size: 16px;
    color: ${colors.darkGrey};
  }
`;

export const PartsListingWrapper = styled.div`
  border-top: 1px solid #dee2e6;
`;

export const ColumnHeading = styled.span`
  padding: 10px 0;
  padding-left: ${props => props.flex.key === 'price' ? '50px': '0'};
  flex-basis: ${props => props.flex && props.flex.key ? flexBasisMap[props.flex.key] : 'auto'};
  justify-content: flex-start;
  // flex-grow: ${props => props.flex && props.flex.grow ? props.flex.grow : '0 0 auto'};
  font-size: ${props => props.dataRow ? '14px' : '12px'};
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: ${props => props.dataRow ? '0.4px' : '0.3px'};
  color: ${props => props.dataRow ? '#363839' : '#878c90'};
`;

export const TableHeadingsWrapper = styled.div`
    display: flex;
    padding: 0 30px 0 15px;
    ${ColumnHeading}:nth-child(3) {
      padding-left: 20px;
    }
    ${ColumnHeading}:nth-child(4) {
      padding-left: 15px;
    }
    ${ColumnHeading}:nth-child(5) {
      padding-left: 15px;
    }
`

export const TableDataRowWrapper = styled(TableHeadingsWrapper)`
  border-top: 1px solid #dee2e6;
  align-items: flex-start;
  padding: 0 30px 0 15px;
  // padding: 0 15px;
`

export const TableDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${TableDataRowWrapper}:last-child {
    border-bottom: 1px solid #dee2e6;
  }
`;

export const ColumnData = styled(ColumnHeading)`
    padding: 14px 0;
    padding-left: ${props => props.flex.key === 'price' ? '50px': '0'};
    margin-top: 0;
    color: ${props => props.nameCol ? '#0d0d0e' : '#363839'};
    font-size: 14px;
    font-weight: ${props => props.nameCol ? '600' : 'normal'};
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
`;


export const PricingExplanation = styled.div`
  padding: 20px 30px 50px 0;
  display: flex;
  flex-direction: row-reverse;
`;

export const PartDescription = styled(ColumnData)`
`;

export const PricingDetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
`;

export const Label = styled.span`
  padding-right: 100px;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #363839;
`;

export const Value = styled(Label)`
  padding-right: 0;
  padding-left: 30px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-align: right;
`;

export const ExplanationBlock = styled.div`
  display: flex;
  flex-flow: column;
  ${PricingDetailRow}:nth-child(4) {
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 15px;
  }
  ${PricingDetailRow}:nth-child(5) ${Label}{
    font-weight: 600;
    color: #363839;
  }
  ${PricingDetailRow}:nth-child(5) ${Value}{
    font-weight: 600;
    font-size: 16px;
    color: #0d0d0e;
  }
`;

export const HorizontalLayout = styled.div`
  display: flex;
  padding: ${props => props.padding ? props.padding : '0 0 0 30px'};
  border-top: ${props => props.borderTopNull ? '' : '1px solid #dee2e6'};
  border-bottom: ${props => props.borderBottom ? '1px solid #dee2e6' : ''};
  ${VerticalLayout}:nth-child(1) {
    border-right-color: rgb(222, 226, 230);
    border-right-style: solid;
    border-right-width: 1px;
  }
`;

export const ActivityMessageRow = styled.div`
  display: flex;
  padding: ${props => props.padding ? props.padding : '0'};
  border-top: ${props => props.messageType === 'auto' ? '' : '1px solid #dee2e6'};
  border-bottom: ${props => props.messageType === 'auto' ? '' : '1px solid #dee2e6'};
`;

export const MessageHistoryWrapper = styled.div`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  padding: ${props => props.padding ? props.padding : '0'};
  ${ActivityMessageRow}:last-child {
    border-bottom: none;
    padding-bottom: 30px;
  }
  ${ActivityMessageRow}:first-child {
    padding-top: 10px;
  }
`;

export const MessageContent = styled.div`
  display: flex;
  padding: 14px 10px;
  flex-direction: ${props => props.flexDirection ? props.flexDirection : 'row'};
`;

export const MessageCreatedAt = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  text-align: right;
  color: ${colors.steel};
`;

export const MessageAccountPhoto = styled.img`
  margin: ${props => props.margin ? props.margin : '0'};
  padding: ${props => props.padding ? props.padding : '10px 0 10px 25px'};
  border: ${props => props.border ? props.border : ''};
`;

export const HeadingWrapper = styled.span`
  flex: 1 0 0;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #363839;
`;

export const HeadingsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.padding ? props.padding : '0 0 10px 30px'};
`;

export const AddMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 30px;
  border-top: 1px solid #dee2e6;
`;

export const MessageText = styled.span`
  flex: 1;
  word-break: break-all;
  font-size: ${p => p.messageType === 'auto' ? '15px' : '14px'};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: ${p => p.messageType === 'auto' ? '-0.4px' : '-0.3px'};;
  color:  ${p => p.messageType === 'auto' ? '#878c90' : '#363839'};
  padding: ${props => props.flexDirection === 'column' ? 0 : '0 10px 0 8px'};
`;

export const MessageUser = styled.span`
  flex: 1;
  word-break: break-all;
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #363839;
  padding: ${props => props.padding? props.padding : '0 0 4px 0'};
`;

export const TabButton = styled.span`
  background-color: ${colors.white};
  padding: ${props => props.padding ? props.padding : '0'};
  margin: ${props => props.margin ? props.margin : '0'};
  border-bottom: ${p => p.isActive === 'true' ? '2px solid #007bff' : '' };
`;

export const MessageDetails = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
`;

export const InputElement = styled.input`
  padding: 0 10px;
  border: 1px solid ${colors.silver};
  border-radius: 6px;
  outline: none;
  font-size: 14px;

  flex: 1;
  height: 46px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  ::placeholder {
    color: ${colors.silver};
  }

  &[disabled] {
    background-color: ${colors.alabaster};
    cursor: not-allowed;
  }

  &[data-error="true"] {
    border: 1px solid ${colors.strawberry};
  }
`;

export const InputGroupButton = styled.button`
  height: 48px;
  border: 0;
  padding: 13px 24px;
  border-radius: 6px;
  background-color: #007bff;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  text-align: center;
  color: #ffffff;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

export const NoUpdates = styled.p`
  padding: 30px 0 20px 30px;
  margin: 0;
`;

export const PurchaseOrderStatusIcon = styled.p`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  font-weight: bold;
  padding-left: 20px;

  span.circle {
    display: inline-block;
    border-radius: 8px;
    padding: 8px;
    margin: 0 8px 0 0;
  }

  span.circle.awaiting {
    background-color: ${colors.burntYellow};
  }

  span.circle.declined {
    background-color: ${colors.strawberry};
  }

  span.circle.approved {
    background-color: ${colors.shamrockGreen};
  }

  span.circle.partially-fulfilled {
    border-radius: 8px;
    background-color: ${colors.white};
  }

  span.circle.fulfilled {
    background-color: ${colors.brightBlue};
  }

  span.circle.default {
    background-color: ${colors.steel};
  }
`;
